export function validNoticeEditorGroup(value: unknown): value is { id: string; name: string } {
  if (!value || typeof value !== 'object') return false;
  const group=value as {id?:unknown;name?:unknown};
  return typeof group.id==='string' && group.id.length>0 && group.id.length<=160 && typeof group.name==='string' && group.name.trim().length>0 && group.name.length<=80;
}
